export enum InvoiceStatus {
  CREATED = 'CREATED',
  PENDING = 'PENDING',
  PAID = 'PAID',
  DONE = 'DONE',
  FAILED = 'FAILED'
}

export enum InvoiceFailedReason {
  PAYMENT_DECLINED = 'PAYMENT_DECLINED',
  GATEWAY_FAILED = 'GATEWAY_FAILED'
}
